import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgStar(props: RootSvgProps) {
  return (
    <RootSvg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2506_20984)">
        <path
          d="M5.67708 4.32259L8.54167 0.624675C8.72934 0.373806 8.95234 0.189519 9.21068 0.0718104C9.46884 -0.0457243 9.73872 -0.104492 10.0203 -0.104492C10.3019 -0.104492 10.5686 -0.0437283 10.8203 0.0777995C11.072 0.199327 11.2934 0.381619 11.4844 0.624675L14.349 4.32259L18.724 5.75488C19.1233 5.89377 19.4358 6.12554 19.6615 6.4502C19.8872 6.77468 20 7.13318 20 7.52572C20 7.71183 19.9737 7.89803 19.9211 8.08431C19.8683 8.27042 19.7818 8.44881 19.6615 8.61947L16.849 12.5518L16.9531 16.7705C16.9531 17.3087 16.7708 17.7644 16.4062 18.1377C16.0417 18.511 15.6061 18.6976 15.0995 18.6976C15.0679 18.6976 14.9045 18.6716 14.6094 18.6195L10 17.3434L5.38932 18.6205C5.30339 18.6545 5.22135 18.6759 5.14323 18.6846C5.0651 18.6933 4.98672 18.6976 4.90807 18.6976C4.40477 18.6976 3.96441 18.511 3.58698 18.1377C3.20955 17.7644 3.02951 17.3087 3.04687 16.7705L3.15104 12.5518L0.338542 8.61947C0.217014 8.44586 0.130208 8.27224 0.078125 8.09863C0.0260417 7.92502 0 7.74247 0 7.55098C0 7.15219 0.11441 6.7877 0.343229 6.45749C0.572049 6.12728 0.891667 5.89308 1.30208 5.75488L5.67708 4.32259ZM6.77083 5.93717L1.875 7.55176L5.02344 12.0059L4.92187 16.8226L10 15.3903L15.1042 16.7966L14.974 11.9788L18.125 7.52572L13.2031 5.93717L10 1.82259L6.77083 5.93717Z"
          fill="#C08A38"
        />
      </g>
      <defs>
        <clipPath id="clip0_2506_20984">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(0 -1 1 0 0 20)"
          />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
